import { useSearchParams } from 'react-router-dom';

import { Typography } from '@sbv-clients/ui-shared';

import SharedAuthLayout from '../../layouts/shared-auth-layout';

export const SharedAuthSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const action = searchParams.get('action');

  const title =
    action === 'register'
      ? 'Registration Successful'
      : 'Reset Password Successful';

  return (
    <SharedAuthLayout isCheckIcon>
      <Typography variant="h1" textAlign="center" mb={8}>
        {title}
      </Typography>
      <Typography textAlign="center">
        You can now login with your updated password to SBV Time and Attendance
        for Healthcare software
      </Typography>
    </SharedAuthLayout>
  );
};
